module.exports = __webpack_public_path__ + "static/accounts_3-728d978044867023367fccd857cbe002.png";